<template>
    <div class="slider-container">
        <input type="range" class="slider"
            v-bind:min="min"
            v-bind:max="max"
            v-bind:step="step"
            v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)" v-bind:disabled="disabled" />
    </div>
</template>

<script>
    export default {
        name: "Slider",
        props: {
            min: [String, Number],
            max: [String, Number],
            step: [String, Number],
            value: [String, Number],
            disabled: Boolean
        }
    }
</script>

<style scoped>
    .slider-container {
        flex: 1;
        display: inline-block;
    }

    .slider-container .slider {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        width: 100%;
        height: 14px;
        background: #d3d3d3;
        outline: none;
        opacity: 0.7;
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        -ms-border-radius: 7px;
        border-radius: 7px;
        -webkit-transition: opacity .2s;
        -moz-transition: opacity .2s;
        -ms-transition: opacity .2s;
        transition: opacity .2s;
    }
    .slider-container .slider:hover {
        opacity: 1;
    }

    /* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
    .slider-container .slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        width: 25px;
        height: 25px;
        background: #247cf0;
        cursor: pointer;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -ms-border-radius: 50%;
        border-radius: 50%;
    }

    .slider-container .slider::-moz-range-thumb {
        width: 25px;
        height: 25px;
        background: #247cf0;
        cursor: pointer;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -ms-border-radius: 50%;
        border-radius: 50%;
    }
</style>
